export default __webpack_public_path__ + "static/media/Image_OB_Searching_CFR@3x.b5e43d50.png";